import * as React from 'react'
import { SpaceProps } from 'styled-system'
import styled from 'styled-components'

import { Box, Icon, TextBody } from '@ally/metronome-ui'
import { muiErrorOutline } from '@ally/metronome-icons'

export type ErrorBannerProps = SpaceProps

const StyledErrorBanner = styled(TextBody)`
  color: #d53540;
`

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  children,
  ...rest
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      mb="md"
      data-allytm-error={children}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      <Box flexShrink={0}>
        <Icon icon={muiErrorOutline} fill="error" mr="xs" size="lg" />
      </Box>
      <StyledErrorBanner size="sm" tag="b" weight="bold" focusOnMount>
        {children}
      </StyledErrorBanner>
    </Box>
  )
}
